import React, { Component, PropTypes } from 'react';
import TableRows from './TableRows';
import { SparkTable } from '../../../ui/spark';
import classnames from 'classnames';

class TablePanel extends Component {
    componentDidMount() {
        this.themeTable = new SparkTable(this.themeTableMount);
    }

    render() {
        return (
            <div
                ref={node => {
                    this.themeTableMount = node;
                }}
            >
                <table
                    id={this.props.id + '-theme-panel-table'}
                    className={classnames('spark-table col-xs-12', {
                        'themes-table': _.isEqual(this.props.contenttype, 'themes')
                    })}
                    role="grid"
                >
                    <thead>
                        <tr>
                            <th data-sort>Content Level</th>
                            <th data-sort="asc">Name</th>
                            <th data-sort>Code</th>
                            <th data-sort>Updated</th>
                            <th data-sort>Status</th>
                            <th>Default</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <TableRows
                        content={this.props.content}
                        onDeleteClick={this.props.onDeleteClick}
                        chain={this.props.chain}
                        hotel={this.props.hotel}
                        setData={this.props.setData}
                        onCopy={this.props.onCopy}
                        defaultContent={this.props.defaultContent}
                        contenttype={this.props.contenttype}
                        onShowInfo={this.props.onShowInfo}
                        uploadUrl={this.props.uploadUrl}
                        itemName={this.props.itemName}
                        category={this.props.category}
                    />
                </table>
            </div>
        );
    }
}

TablePanel.propTypes = {
    content: PropTypes.array,
    category: PropTypes.string,
    onShowInfo: PropTypes.func,
    onCopy: PropTypes.func,
    uploadUrl: PropTypes.string,
    itemName: PropTypes.string
};

export default TablePanel;



// WEBPACK FOOTER //
// ./src/components/pages/manage/common/TablePanel.js